import { t } from '../i18n';
import { isDemo } from './api';

/** Local demo only; real Telegram uploads always use the file picker. */
export async function addDemoSources(addFiles: (files: File[], slot: 'reaction') => Promise<void>): Promise<void> {
  if (!isDemo()) return;
  const response = await fetch(`${import.meta.env.BASE_URL}demo/source.mp4`);
  if (!response.ok) throw new Error('Demo source unavailable');
  const blob = await response.blob();
  await addFiles([1, 2].map(index => new File([blob], t('editor.demo.file', { n: index }), { type: 'video/mp4' })), 'reaction');
}
